export default {
  menu: {
    sports: "Thể Thao",
    referAndEarn: "Giới Thiệu và Kiếm Tiền",
    referDesc: "hoa hồng lên đến 60%",
    copyLink: "Sao Chép Liên Kết",
    hot: "Nổi Bật",
    favorites: "Yêu Thích",
    recent: "Gần Đây",
    vipClub: "Câu Lạc Bộ VIP",
    bonus: "Tiền Thưởng",
    bonusGames: "Trò Chơi Thưởng",
    affiliate: "Đại Lý",
    promotion: "Khuyến Mãi",
    rewards: "Phần Thưởng",
    help: "Trợ Giúp",
    feedback: "Phản Hồi",
    downloadApp: "Tải Ứng Dụng",
    claimBonus: "Nhận Thưởng",
    redeemCode: 'Đổi Mã',
    redeemDesc: 'Nhận Phần Thưởng Miễn Phí',
    liveSupport: "Hỗ Trợ Trực Tiếp",
    language: "Ngôn Ngữ",
	search: "search"
  }
}
